import { Injectable } from '@angular/core';
import { ConditionGenerator, ICondition, IConditionFactory } from '../interfaces';
import { Options } from '../models';
import {
    PageCountBySiteCondition,
    PageCountCondition,
    ProactiveFormTagValidCondition,
    SkillAvailableCondition,
    TimeSinceLastInviteBySiteCondition,
    TimeSinceLastVisitByPageCondition,
    TimeSpentCondition,
    WithdrawInvitationCondition
} from '../common/conditions';
import { NotificationService, OptionsService, SettingsService, SkillService, VisitService } from '.';

@Injectable()
export class ConditionFactory implements IConditionFactory {
  private conditionGenerators: Map<string, ConditionGenerator>;

  constructor(
    private settings: SettingsService,
    private skillService: SkillService,
    private visitService: VisitService,
    private optionsService: OptionsService,
    private notificationService: NotificationService
  ) {
    this.conditionGenerators = new Map<string, ConditionGenerator>();
    this.initConditionsRegistry();
  }

  addCondition(name: string, conditionGenerator: ConditionGenerator): void {
    this.conditionGenerators.set(name, conditionGenerator);
  }

  getCondition(name: string, applicationOptions: Options, conditionOptions: any): ICondition {
    const generator = this.conditionGenerators.get(name);
    if (!generator) throw new Error(`Unsupported condition: '${name}.`);

    const condition = generator(applicationOptions, conditionOptions);
    return condition;
  }

  initConditionsRegistry(): void {
    this.addCondition('DurationSpentOnPage', (ao, co) => new TimeSpentCondition(co, this.notificationService));
    this.addCondition('TimeSinceLastInviteBySite', (ao, co) => new TimeSinceLastInviteBySiteCondition(this.settings.lastInvitationTimestamp, co, this.notificationService));
    this.addCondition('PageCount', (ao, co) => new PageCountCondition(ao.Location, this.visitService.visits, co, this.notificationService));
    this.addCondition('PageCountBySite', (ao, co) => new PageCountBySiteCondition(this.visitService.visits, co, this.notificationService));
    this.addCondition('SkillAvailable', (ao, co) => new SkillAvailableCondition(ao, this.skillService, this.notificationService));
    this.addCondition('WithdrawTimeout', (ao, co) => new WithdrawInvitationCondition(co, this.notificationService));
    this.addCondition('TimeSinceLastVisitByPage', (ao, co) => new TimeSinceLastVisitByPageCondition(ao.Location, this.visitService.visits, co, this.notificationService));
    this.addCondition('ProactiveFormTagValid', (ao, co) => new ProactiveFormTagValidCondition(this.optionsService, ao.FormTagName, this.notificationService));
  }
}
